export const JOB_ACTION_BUTTON_ROW_CLASS =
  "flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:flex-wrap sm:items-stretch";

export const JOB_ACTION_BUTTON_CLASS =
  "h-10 w-full justify-center gap-2 px-4 text-xs font-bold uppercase tracking-[0.08em] sm:w-auto";

export const JOB_ACTION_BUTTON_COMPACT_CLASS =
  "h-10 w-full justify-center gap-2 px-4 text-xs font-bold uppercase tracking-[0.08em] sm:h-9 sm:w-auto sm:px-3";
